import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import SidebarItemIcon from "./icon";
import Arrow from "./arrow";
import Membership from "./membership";
import Help from "./help";
import MediaQuery from 'react-responsive'
import NotificationItem from "../notifications/notification-icon";
import meApi from "../../lib/users/me-api";
import companiesApi from "../../lib/companies/companies-api";
import auth from '../../lib/users/auth';
import MediaHelper from '../../lib/helpers/media';
import { MessagesItem } from "../topbar";
import { animated, useSpring } from '@react-spring/web'

import {
    COMPANY_BOOK_CO_WORKING_SPACES,
    COMPANY_BOOK_EVENTS,
    COMPANY_BOOK_MEETING_ROOMS,
} from '../../utils/permissions';

const sidebar = [
    {
        name: 'Dashboard',
        icon: <SidebarItemIcon/>,
        url: '/mydmc/',
    },
    {
        name: 'Co-Working',
        icon: <SidebarItemIcon/>,
        url: '/mydmc/co-working',
        permission: COMPANY_BOOK_CO_WORKING_SPACES,
        children: [
            {
                name: 'Book',
                url: '/mydmc/co-working/bookings/new',
            },
            {
                name: 'Bookings',
                url: '/mydmc/co-working/bookings',
            }
        ]
    },
    {
        name: 'Events',
        icon: <SidebarItemIcon/>,
        url: '/mydmc/events',
        permission: COMPANY_BOOK_EVENTS,
        children: [
            {
                name: 'Tickets',
                url: '/mydmc/events/bookings',
            }
        ]
    },
    {
        name: 'Meetings',
        icon: <SidebarItemIcon/>,
        url: '/mydmc/meeting-rooms',
        permission: COMPANY_BOOK_MEETING_ROOMS,
        children: [
            {
                name: 'Rooms',
                url: '/mydmc/meeting-rooms/'
            },
            {
                name: 'Bookings',
                url: '/mydmc/bookings',
            }
        ]
    },
    {
        name: 'Support',
        icon: <SidebarItemIcon/>,
        url: '/',
    },
]

const SidebarDesktop = ({ springs, responsive = false, onClose = () => {} }) => {
    const [ me, setMe ] = useState(null);
    const [ company, setCompany ] = useState(null);

    const getCompany = (id) => {
        companiesApi.getCompany(id).then(({ data }) => {
            setCompany(data)
        })
    }

    const isOwner = auth.hasPermission('company_owner') || auth.hasPermission('company_manager');
    console.log('is owner:', isOwner)
    useEffect(() => {
        meApi.me().then(data => {
            setMe(data);
            getCompany(data?.company_id);
        });
    }, []);

    const membership = company?.company_memberships?.[0];

    const image = auth.getUser()?.user_profile?.profile_img;

    return (
        <animated.div
            className={`sidebar ${responsive ? 'sidebar__responsive' : ''}`}
            style={{
                ...springs,
            }}
        >
            <div className="sidebar__inner">
                <div className="sidebar__head">
                    <div className="sidebar-responsive__group">
                        { responsive && <img className="sidebar__close" src="/assets/sidebar-menu-close.svg" onClick={onClose}/> }
                        <a href="/mydmc">
                            <img className="sidebar__logo" src="/assets/SVG/awesome-dmcmyDMC - dark background.svg"/>
                        </a>
                    </div>
                </div>

                <div className="sidebar__content">
                    { sidebar?.filter(item => {
                        if (item?.hasOwnProperty('permission')) return auth.hasPermission(item?.permission) || isOwner;

                        return true;
                    })?.map((item, index) => {
                        const Icon = item.icon;

                        return (
                            item.hasOwnProperty('children') ? <div className="sidebar__group">
                                <a key={index} href={item?.url} className="sidebar__item">
                                    <div className="sidebar-item__content">
                                        { Icon ?? Icon }
                                        <div className="sidebar-item__text">{ item?.name }</div>
                                    </div>
                                </a>
                                <div className="sidebar-group__content">
                                    { item?.children?.filter(child => auth.hasPermission(child?.permission) || isOwner)?.map((child, childIndex) => {
                                        return (
                                            <a key={childIndex} href={child?.url} className="sidebar__item sidebar__item--child">
                                                <div className="sidebar-item__content">
                                                    <div className="sidebar-item__text">{ child.name }</div>
                                                </div>
                                                <Arrow/>
                                            </a>
                                        )
                                    })}
                                </div>
                            </div> : <a key={index} href={item?.url} className="sidebar__item">
                                    <div className="sidebar-item__content">
                                        { Icon ?? <Icon/> }
                                        <div className="sidebar-item__text">{ item?.name }</div>
                                    </div>
                                </a>
                        )
                    })}
                </div>
            </div>

            <div className="sidebar__bottom">
                <div className="sidebar-bottom__links">
                    <a href="/mydmc/account" className="sidebar-bottom__link">
                        <div className="sidebar-bottom-link__icon" style={{
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundImage: `url('${image ? MediaHelper.formatPrivatePath(`${auth.getUser()?.user_profile?.profile_img}`) : '/assets/user-icon.svg'}')`
                        }}></div>
                        <h3 className="sidebar-bottom-link__text">My Account</h3>
                    </a>

                    <a href="/mydmc/account/company" className="sidebar-bottom__link">
                        <div className="sidebar-bottom-link__icon"></div>
                        <h3 className="sidebar-bottom-link__text">My Company</h3>
                    </a>
                </div>

                { membership !== undefined && <a className="sidebar-bottom__membership" href="/mydmc/account/memberships">
                    <Membership/>
                    <h3 className="sidebar-bottom-membership__text">{ membership?.membership?.name }</h3>
                </a> }

                <div className="sidebar-bottom__helping">
                    <a href="/logout" className="sidebar-bottom__help">
                            <Help/>
                        <h3 className="sidebar-bottom-help__text">Logout</h3>
                    </a>

                    <a href="#" className="sidebar-bottom__help">
                            <Help/>
                        <h3 className="sidebar-bottom-help__text">Help</h3>
                    </a>
                </div>
            </div>
        </animated.div>
    )
}

const SidebarTablet = () => {
    const [ showSidebar, setShowSidebar ] = useState(false);

    const [ springs, api ] = useSpring(() => ({
        from: {
            x: '-100%',
        },
    }))

    const onShow = () => {
        setShowSidebar(true);

        api.start({
            from: {
                x: '-100%',
            },
            to: {
                x: '0%',
            },
        })
    }

    const onClose = () => {
        setShowSidebar(false);

        api.start({
            from: {
                x: '0%',
            },
            to: {
                x: '-100%',
            },
        })
    }

    return (
        <>
            <div className="sidebar-responsive">
                <div className="sidebar-responsive__group">
                    <img className="sidebar-responsive__menu" src={showSidebar ? "/assets/sidebar-menu-close.svg" : "/assets/sidebar-menu.svg"} onClick={onShow}/>
                    <img className="sidebar-responsive__logo" src="/assets/SVG/awesome-dmcmyDMC - dark background.svg"/>
                </div>

                <div className="sidebar-responsive__group">
                    <MessagesItem/>
                    <NotificationItem/>
                </div>
            </div>

            <SidebarDesktop
                responsive={true}
                springs={springs}
                onClose={onClose}
            />
        </>
    )
}

export default function Sidebar() {
    return <>
        <MediaQuery minWidth={992}>
            <SidebarDesktop/>
        </MediaQuery>

        <MediaQuery maxWidth={992}>
            <SidebarTablet/>
        </MediaQuery>
    </>
}



